export default __webpack_public_path__ + "static/media/trincheta.f6ab2d7a.png";